import React from 'react';

export const NotFound = (): JSX.Element => {
    return (
        <div>Not found</div>
    );
};
